export const DEV_INFO_ENABLED = !['uat', 'prod'].includes(import.meta.env.VITE_APP_ENVIRONMENT);

export const IS_PROD_MODE = ['dev', 'uat', 'prod'].includes(import.meta.env.VITE_APP_ENVIRONMENT);

export const IS_LOCAL_MODE = ['local'].includes(import.meta.env.VITE_APP_ENVIRONMENT);

export const IS_E2E_MODE = ['e2e'].includes(import.meta.env.VITE_APP_ENVIRONMENT);
